const account = {
  account: {
    hero: {
      myAccount: "My Account",
      donorFallback: "Donor",
      donateAgain: "Donate Again",
      signOut: "Sign Out",
    },
    noDonor: {
      title: "No donor profile yet",
      description:
        "Make your first donation and we'll automatically link it to your account.",
      browseCauses: "Browse Causes",
    },
    stats: {
      lifetimeTotal: "Lifetime Total",
      donations: "Donations",
      thisFy: "This FY",
      activeRecurring: "Active Recurring",
    },
    tabs: {
      donations: "Donations",
      recurring: "Recurring",
      statement: "80G Statement",
      profile: "Profile",
    },
    statement: {
      title: "Download 80G yearly statement",
      description:
        "Consolidated PDF of all your eligible donations for the selected financial year.",
      financialYear: "Financial Year",
      noDonations: "No successful donations yet",
      fyOption: "FY {{fy}}",
      download: "Download Statement",
    },
    toast: {
      signedOut: "Signed out",
      noStatementDonations: "No 80G donations in this financial year",
      subscriptionStatus: "Subscription {{status}}",
      failed: "Failed",
      profileUpdated: "Profile updated",
    },
    donationsTable: {
      empty: "You haven't made any donations yet.",
      makeFirst: "Make Your First Donation",
      date: "Date",
      receipt: "Receipt",
      cause: "Cause",
      mode: "Mode",
      amount: "Amount",
      status: "Status",
      receiptAction: "Receipt",
      download: "Download",
      pending: "Pending",
    },
    recurringTable: {
      empty: "You have no recurring donation plans.",
      frequency: "Frequency",
      amount: "Amount",
      nextPayment: "Next Payment",
      started: "Started",
      status: "Status",
      actions: "Actions",
      pause: "Pause",
      resume: "Resume",
      cancel: "Cancel",
    },
    profile: {
      title: "Donor profile",
      description:
        "Used on every receipt — please keep your PAN and address up to date for 80G eligibility.",
      fullName: "Full Name *",
      mobile: "Mobile *",
      email: "Email",
      pan: "PAN (for 80G)",
      panPlaceholder: "ABCDE1234F",
      dateOfBirth: "Date of Birth",
      country: "Country",
      address: "Address",
      city: "City",
      state: "State",
      pincode: "Pincode",
      save: "Save Profile",
    },
  },
  applyAdmission: {
    eyebrow: "Admission",
    title: "Apply for Admission",
    subtitle:
      "Complete each step below — our team will contact you within 3 working days.",
  },
  admissionForm: {
    steps: {
      applicant: {
        label: "Applicant Information",
        shortLabel: "Applicant",
        eyebrow: "Step 1",
        subtitle: "About the person submitting this form",
      },
      elder: {
        label: "Elder Information",
        shortLabel: "Elder",
        eyebrow: "Step 2",
        subtitle: "About the elderly person being recommended",
      },
      income: {
        label: "Income Information",
        shortLabel: "Income",
        eyebrow: "Step 3",
        subtitle: "Helps assess eligibility and seva category",
      },
      contacts: {
        label: "Contact Persons",
        shortLabel: "Contacts",
        eyebrow: "Step 4",
        subtitle: "At least one local contact, preferably three",
      },
      family: {
        label: "Family Details & Remarks",
        shortLabel: "Family",
        eyebrow: "Step 5",
        subtitle: "Add family members and any additional notes before review",
      },
    },
    fields: {
      applicantName: {
        label: "Applicant Name",
        placeholder: "Your full name",
      },
      mobile: {
        label: "Mobile Number",
        placeholder: "+91 …",
      },
      address: {
        label: "Address",
        placeholder: "Street, city, district, state, pincode",
      },
      relationship: {
        label: "Relationship with Elder",
        placeholder: "Select relationship...",
        searchPlaceholder: "Search relationship...",
        emptyText: "No relationship found.",
      },
      elderName: {
        label: "Elder Name",
        placeholder: "Full name",
      },
      fatherName: {
        label: "Father's Name",
        placeholder: "Father's name",
      },
      age: {
        label: "Age",
        placeholder: "e.g. 72",
      },
      district: {
        label: "District",
        placeholder: "Select district...",
        searchPlaceholder: "Search district...",
        emptyText: "No district found.",
      },
      city: {
        label: "City",
        searchPlaceholder: "Search city...",
        emptyDisabled: "Select a district first.",
        empty: "No city found.",
      },
      area: {
        label: "Area",
        searchPlaceholder: "Search area...",
        emptyDisabled: "Select a city first.",
        empty: "No area found.",
      },
      currentLivingSituation: {
        label: "Current Living Situation",
        placeholder: "Where the elder currently stays and with whom",
      },
      physicalCondition: {
        label: "Physical Condition",
        placeholder: "Mobility, chronic conditions, daily assistance required",
      },
      reasonForAdmission: {
        label: "Reason for Admission",
        placeholder: "Why is admission being requested?",
      },
      pensionDetails: {
        label: "Pension Details",
        placeholder: "e.g. ₹2,500 / month state pension",
      },
      otherIncome: {
        label: "Other Income",
        placeholder: "Rent, family support, etc.",
      },
      contact1: {
        label: "Contact Person 1 (Name + Mobile)",
        placeholder: "e.g. Ramesh Patel — +91 …",
      },
      contact2: {
        label: "Contact Person 2 (Name + Mobile)",
        placeholder: "e.g. Sita Ben — +91 …",
      },
      contact3: {
        label: "Contact Person 3 (Name + Mobile)",
        placeholder: "Optional",
      },
      additionalRemarks: {
        label: "Additional Remarks",
        placeholder:
          "Special needs, language, dietary notes, religious considerations…",
      },
    },
    consent:
      "By submitting, you confirm the information shared is accurate to the best of your knowledge. Our team will review your application and contact you within 3 working days.",
    nav: {
      previous: "Previous",
      next: "Next",
      remainingOne: "{{count}} step remaining",
      remainingOther: "{{count}} steps remaining",
    },
    submit: {
      saving: "Saving…",
      update: "Update Application",
      save: "Save Application",
      submit: "Submit Application",
    },
    toast: {
      updated: "Admission application updated successfully.",
      saved: "Admission application saved successfully.",
      updateFailed: "Failed to update application. Please try again.",
      submitFailed: "Failed to submit application. Please try again.",
    },
    location: {
      cityPlaceholderDisabled: "Select district first",
      cityPlaceholder: "Select city...",
      areaPlaceholderDisabled: "Select city first",
      areaPlaceholder: "Select area...",
    },
    validation: {
      applicantNameRequired: "Applicant name is required.",
      applicantMobileRequired: "Applicant mobile number is required.",
      applicantMobileInvalid:
        "Enter a valid mobile number for the selected country.",
      applicantAddressRequired: "Applicant address is required.",
      relationshipRequired: "Relationship with elder is required.",
      elderNameRequired: "Elder name is required.",
      ageRequired: "Valid elder age is required.",
      districtRequired: "District is required.",
      cityRequired: "City is required.",
      areaRequired: "Area is required.",
      reasonRequired: "Reason for admission is required.",
      emergencyContactRequired: "At least one emergency contact is required.",
    },
  },
  admissionInquiry: {
    eyebrow: "Admission",
    title: "Admission Inquiry Form",
    subtitle:
      "Share the elder's health, income and family details — our care team will review and contact you within 3 working days.",
  },
  visitorForm: {
    eyebrow: "Visitor Feedback",
    title: "Visitor Feedback Form",
    subtitle:
      "Share your visit details, family information and feedback — our team will review and welcome you at Jivandhara.",
    submit: "Submit Visit Feedback",
    submitting: "Submitting…",
    reset: "Reset Form",
    toast: {
      success: "Visitor feedback submitted successfully.",
      error: "Unable to submit visitor feedback. Please try again.",
    },
    validation: {
      dateRequired: "Please select the visit date.",
      nameRequired: "Please enter the visitor name.",
      mobileInvalid: "Enter a valid mobile number for the selected country.",
      residencePhoneInvalid: "Enter a valid residence phone number.",
      emailInvalid: "Enter a valid email address.",
      ageInvalid: "Enter a valid age between 1 and 120.",
      referrerMobileInvalid:
        "Enter a valid referrer mobile for the selected country.",
      familyNameRequired:
        "Each family member with a relationship needs a name.",
      familyRelationshipRequired:
        "Each family member with a name needs a relationship.",
    },
  },
  visitorInquiryForm: {
    eyebrow: "Visitor Inquiry",
    title: "Visitor Inquiry Form",
    subtitle:
      "Planning a visit? Share your visit details, reason for visit and reference — our team will welcome you at Jivandhara.",
    submit: "Submit Visit Inquiry",
    submitting: "Submitting…",
    reset: "Reset Form",
    toast: {
      success: "Visitor inquiry submitted successfully.",
      error: "Unable to submit visitor inquiry. Please try again.",
    },
    validation: {
      dateRequired: "Please select the visit date.",
      nameRequired: "Please enter the visitor name.",
      mobileInvalid: "Enter a valid mobile number for the selected country.",
      residencePhoneInvalid: "Enter a valid residence phone number.",
      emailInvalid: "Enter a valid email address.",
      ageInvalid: "Enter a valid age between 1 and 120.",
      referrerMobileInvalid:
        "Enter a valid referrer mobile for the selected country.",
      familyNameRequired:
        "Each family member with a relationship needs a name.",
      familyRelationshipRequired:
        "Each family member with a name needs a relationship.",
    },
  },
  visitorSuccessDialog: {
    title: "Visit Registration Submitted",
    description:
      "Thank you for registering your visit to Jivandhara. Your details have been received by our team.",
    visitor: "Visitor",
    whatHappensNext: "What happens next",
    step1: "Our team will review the visit details you shared.",
    contactBefore: "We will contact you within",
    workingDays: "2 working days",
    contactAfter: "if any confirmation or guidance is needed.",
    done: "Done",
    backToHome: "Back to Home",
  },
  inquiryForm: {
    steps: {
      inquiry: {
        label: "Inquiry Details",
        shortLabel: "Inquiry",
        eyebrow: "Step 1",
        subtitle: "About the person making this inquiry",
      },
      family: {
        label: "Family & Notes",
        shortLabel: "Family",
        eyebrow: "Step 2",
        subtitle: "Add family members and any additional notes",
      },
      elder: {
        label: "Elder Details",
        shortLabel: "Elder",
        eyebrow: "Step 3",
        subtitle: "About the elderly person being recommended",
      },
      income: {
        label: "Income & Financier",
        shortLabel: "Income",
        eyebrow: "Step 4",
        subtitle: "Income sources and other financier details",
      },
      health: {
        label: "Health Conditions",
        shortLabel: "Health",
        eyebrow: "Step 5",
        subtitle: "Disabilities, diseases and allergies",
      },
      treatment: {
        label: "Current Treatment",
        shortLabel: "Treatment",
        eyebrow: "Step 6",
        subtitle: "Ongoing treatment and medicines",
      },
      operation: {
        label: "Operation History",
        shortLabel: "Operation",
        eyebrow: "Step 7",
        subtitle: "Past surgeries and recovery medication",
      },
      notes: {
        label: "Additional Notes",
        shortLabel: "Notes",
        eyebrow: "Step 8",
        subtitle: "Share any extra information for our team",
      },
    },
    fields: {
      applicationDate: {
        label: "Application Date",
      },
      inquirerName: {
        label: "Inquirer Name",
        placeholder: "Full name of the person inquiring",
      },
      inquirerMobile: {
        label: "Inquirer Mobile",
        placeholder: "10-digit mobile number",
      },
      inquirerEmail: {
        label: "Inquirer Email",
        placeholder: "Email address",
      },
      referencePersonName: {
        label: "Reference Person Name",
        placeholder: "Full name of the reference person",
      },
      referencePersonMobile: {
        label: "Reference Person Mobile Number",
        placeholder: "10-digit mobile number",
      },
      district: {
        label: "District",
        placeholder: "Select district...",
        searchPlaceholder: "Search district...",
        emptyText: "No district found.",
      },
      city: {
        label: "City",
        searchPlaceholder: "Search city...",
        emptyDisabled: "Select a district first.",
        empty: "No city found.",
      },
      area: {
        label: "Area",
        searchPlaceholder: "Search area...",
        emptyDisabled: "Select a city first.",
        empty: "No area found.",
      },
      pincode: {
        label: "Pincode",
        placeholder: "6-digit pincode",
      },
      landmark: {
        label: "Landmark",
        placeholder: "e.g. Near Shanti Nagar Bus Stop",
      },
      elderName: {
        label: "Elder Name",
        placeholder: "Full name of the elder",
      },
      elderWeight: {
        label: "Elder's Weight",
        placeholder: "Weight in kg (e.g. 65)",
      },
      sameAsInquirerAddress: {
        label: "Same as parent address",
      },
      elderDistrict: {
        label: "Elder District",
        placeholder: "Select district...",
        searchPlaceholder: "Search district...",
        emptyText: "No district found.",
      },
      elderCity: {
        label: "Elder City",
        searchPlaceholder: "Search city...",
        emptyDisabled: "Select a district first.",
        empty: "No city found.",
      },
      elderArea: {
        label: "Elder Area",
        searchPlaceholder: "Search area...",
        emptyDisabled: "Select a city first.",
        empty: "No area found.",
      },
      elderPincode: {
        label: "Elder Pincode",
        placeholder: "6-digit pincode",
      },
      elderLandmark: {
        label: "Elder Landmark",
        placeholder: "e.g. Opposite Maninagar Railway Station",
      },
      physicalHealthStatus: {
        label: "Physical Health Status",
        placeholder: "General mobility and physical condition",
      },
      reasonForAdmission: {
        label: "Reason for Admission",
        placeholder: "Why is admission being requested?",
      },
      pensionAmount: {
        label: "Pension Amount",
        placeholder: "e.g. 8500.00",
      },
      otherIncome: {
        label: "Other Income",
        placeholder: "e.g. 2000.00",
      },
      otherFinancierName: {
        label: "Other Financier Name",
        placeholder: "e.g. Rajesh Shah",
      },
      otherFinancierNumber: {
        label: "Other Financier Number",
        placeholder: "e.g. 9876543210",
      },
      otherFinancierEmail: {
        label: "Other Financier Email",
        placeholder: "e.g. rajesh@example.com",
      },
      hasPhysicalDisability: {
        label: "Has a physical disability?",
      },
      physicalDisabilityDetails: {
        label: "Physical Disability Details",
        placeholder: "e.g. Limited mobility in right knee.",
      },
      hasMentalHealthIssue: {
        label: "Has a previous/current mental health issue?",
      },
      mentalHealthIssueDetails: {
        label: "Mental Health Issue Details",
        placeholder: "Describe the condition",
      },
      hasExistingDisease: {
        label: "Has an existing disease?",
      },
      diseaseDetails: {
        label: "Disease Details",
        placeholder: "e.g. Hypertension",
      },
      hasFoodAllergy: {
        label: "Has a food allergy?",
      },
      foodAllergyDetails: {
        label: "Food Allergy Details",
        placeholder: "Describe the food allergy",
      },
      hasMedicineAllergy: {
        label: "Has a medicine allergy?",
      },
      medicineAllergyDetails: {
        label: "Medicine Allergy Details",
        placeholder: "e.g. Allergic to penicillin.",
      },
      specialMedicalInstructions: {
        label: "Special Medical Instructions",
        placeholder: "e.g. Low-salt diet, monitor BP daily.",
      },
      currentlyUnderTreatment: {
        label: "Currently under treatment?",
      },
      currentDoctorName: {
        label: "Current Doctor Name",
        placeholder: "e.g. Dr. Mehul Shah",
      },
      currentHospitalName: {
        label: "Current Hospital Name",
        placeholder: "e.g. Apollo Hospital",
      },
      currentHospitalAddress: {
        label: "Current Hospital Address",
        placeholder: "e.g. Bhat, Gandhinagar",
      },
      takesCurrentMedicines: {
        label: "Takes current medicines?",
      },
      medicines: {
        label: "Current Medicines",
        addMedicine: "Add Medicine",
        medicine: "Medicine",
        remove: "Remove medicine",
        treatmentName: "Treatment Name",
        treatmentNamePlaceholder: "e.g. Blood pressure control",
        treatmentSearchPlaceholder: "Search treatment...",
        treatmentEmpty: "No treatment found.",
        treatmentOther: "Other (enter manually)",
        treatmentBackToList: "Choose from list instead",
        name: "Medicine Name",
        namePlaceholder: "e.g. Amlodipine",
        dosage: "Dosage",
        dosagePlaceholder: "e.g. 5mg",
        frequency: "Frequency",
        frequencyPlaceholder: "e.g. Once daily",
      },
      hadOperationBefore: {
        label: "Had an operation before?",
      },
      operations: {
        label: "Operations",
        addOperation: "Add Operation",
        operation: "Operation",
        remove: "Remove operation",
        type: "Operation Type",
        typePlaceholder: "e.g. Cataract surgery",
        date: "Operation Date",
        doctorName: "Operation Doctor Name",
        doctorNamePlaceholder: "e.g. Dr. Anita Desai",
        hospitalName: "Operation Hospital Name",
        hospitalNamePlaceholder: "e.g. Netra Eye Care",
        district: {
          label: "Hospital District",
          placeholder: "Select district...",
          searchPlaceholder: "Search district...",
          emptyText: "No district found.",
        },
        city: {
          label: "Hospital City",
          placeholder: "Select city...",
          searchPlaceholder: "Search city...",
          emptyDisabled: "Select a district first.",
          empty: "No city found.",
        },
        area: {
          label: "Hospital Area",
          placeholder: "Select area...",
          searchPlaceholder: "Search area...",
          emptyDisabled: "Select a city first.",
          empty: "No area found.",
        },
        details: "Operation Details",
        detailsPlaceholder: "Outcome and recovery notes",
        takesRecoveryMedicine: "Takes recovery medicine?",
        recoveryMedicineDetails: "Recovery Medicine Details",
        recoveryMedicineDetailsPlaceholder:
          "e.g. Antibiotic eye drops for 2 weeks.",
      },
      additionalNotes: {
        label: "Additional Notes",
        placeholder: "e.g. Prefers vegetarian Jain food.",
      },
      familyMembers: {
        label: "Family Members",
        addMember: "Add Member",
        member: "Member",
        remove: "Remove member",
        name: "Name",
        namePlaceholder: "Family member name",
        relationship: "Relationship",
        relationshipPlaceholder: "Select relationship...",
        relationshipSearch: "Search relationship...",
        relationshipEmpty: "No relationship found.",
        relationshipOther: "Other (enter manually)",
        relationshipCustomPlaceholder: "Enter relationship name",
        relationshipBackToList: "Choose from list instead",
        mobile: "Mobile",
        mobilePlaceholder: "Mobile number",
        details: "Details",
        detailsPlaceholder: "e.g. Lives in Ahmedabad, primary contact.",
      },
    },
    consent:
      "By submitting, you confirm the information shared is accurate to the best of your knowledge. Our team will review your inquiry and contact you within 3 working days.",
    nav: {
      previous: "Previous",
      next: "Next",
      remainingOne: "{{count}} step remaining",
      remainingOther: "{{count}} steps remaining",
    },
    submit: {
      saving: "Saving…",
      update: "Update Inquiry",
      save: "Save Inquiry",
      submit: "Submit Inquiry",
    },
    confirmDialog: {
      title: "Confirm Your Submission",
      description:
        "Please review the details below before submitting your admission inquiry. You can go back to make changes if needed.",
      inquirer: "Inquirer",
      elder: "Elder",
      applicationDate: "Application Date",
      consentNote:
        "By submitting, you confirm the information shared is accurate to the best of your knowledge. Our team will review your inquiry and contact you within 3 working days.",
      goBack: "Go Back & Edit",
      confirmSubmit: "Confirm & Submit",
      submitting: "Submitting…",
    },
    toast: {
      updated: "Admission inquiry updated successfully.",
      saved: "Admission inquiry saved successfully.",
      updateFailed: "Failed to update inquiry. Please try again.",
      submitFailed: "Failed to submit inquiry. Please try again.",
    },
    validation: {
      applicationDateRequired: "Application date is required.",
      inquirerNameRequired: "Inquirer name is required.",
      inquirerMobileRequired: "Inquirer mobile number is required.",
      inquirerMobileInvalid:
        "Enter a valid mobile number for the selected country.",
      inquirerEmailRequired: "Inquirer email is required.",
      inquirerEmailInvalid: "Enter a valid email address.",
      referencePersonMobileInvalid:
        "Enter a valid reference person mobile for the selected country.",
      districtRequired: "District is required.",
      cityRequired: "City is required.",
      areaRequired: "Area is required.",
      pincodeRequired: "Valid 6-digit pincode is required.",
      elderNameRequired: "Elder name is required.",
      elderWeightInvalid: "Enter a valid elder weight between 1 and 500 kg.",
      elderDistrictRequired: "Elder district is required.",
      elderCityRequired: "Elder city is required.",
      elderAreaRequired: "Elder area is required.",
      elderPincodeRequired: "Valid 6-digit elder pincode is required.",
      reasonRequired: "Reason for admission is required.",
      otherIncomeRequired: "Other income is required.",
      familyMemberNameRequired: "Family member {{number}} name is required.",
      familyMemberRelationshipRequired:
        "Family member {{number}} relationship is required.",
      familyMemberMobileRequired:
        "Family member {{number}} mobile number is required.",
      familyMemberMobileInvalid:
        "Family member {{number}} needs a valid mobile for the selected country.",
      familyMemberDetailsRequired:
        "Family member {{number}} details is required.",
    },
  },
  successDialog: {
    title: "Application Submitted Successfully",
    description:
      "Thank you for applying for admission at Jivandhara. Your application has been received and is now under review by our care team.",
    applicant: "Applicant",
    elder: "Elder",
    whatHappensNext: "What happens next",
    step1: "Our team will carefully review the details you shared.",
    contactBefore: "We will contact you within",
    workingDays: "3 working days",
    contactAfter: "on the mobile number provided.",
    done: "Done",
    backToHome: "Back to Home",
  },
  formStepper: {},
};

export default account;
